import React from 'react'
import styled, { css } from 'styled-components'

const ButtonWrapper = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 42px;
  flex: 1;

  margin-bottom: ${(props) => props.marginBottom}px;

  transition: all 0.2s;

  background-color: ${(props) => props.bgColor};
  border-radius: 4px;
  border: 1px solid
    ${(props) => (props.outline ? 'rgba(151, 151, 151, 0.5)' : 'transparent')};

  color: ${(props) => (props.outline ? '#B0BAC9' : '#fff')};

  ${(props) =>
    props.active &&
    css`
      border-color: #4c84ff;
      color: #4c84ff;
    `};

  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;

  white-space: nowrap;

  ${(props) =>
    props.block &&
    css`
      min-width: 180px;
      padding: 0 20px 0 20px;
    `}

  ${(props) =>
    props.maxSize &&
    css`
      max-width: 200px;
    `}

  &:focus,
  &:active {
    outline: none;
  }

  &:hover > div:first-child {
    background-color: ${(props) => (props.outline ? 'grey' : 'white')};
    opacity: 0.1;
  }

  cursor: pointer;
  overflow: hidden;
  outline: none;
`

const StyledDisabledOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: 10;

  background-color: white;
  opacity: 0;
  transition: all 0.2s;

  &.active {
    opacity: 0.2;
    cursor: not-allowed;
  }
`

const StyledButtonText = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export default ({
  children,
  active = false,
  bgColor = '#4c84ff',
  disabled = false,
  outline = false,
  block = false,
  marginBottom = 12,
  maxSize = false,
  ...rest
}) => {
  return (
    <ButtonWrapper
      {...rest}
      outline={outline}
      bgColor={bgColor}
      disabled={disabled}
      active={active}
      block={block}
      marginBottom={marginBottom}
      maxSize={maxSize}
    >
      <StyledDisabledOverlay
        outline={outline}
        className={disabled ? 'active' : ''}
      />
      <StyledButtonText>{children}</StyledButtonText>
    </ButtonWrapper>
  )
}
